import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {PaymentGuard} from '../../../core/guards/payment.guard';

const routes: Routes = [
    {
        path: 'alipay',
        canActivate: [PaymentGuard],
        loadChildren: './alipay-payment/alipay-payment.module#AlipayPaymentModule'
    },
    {
        path: 'apple',
        canActivate: [PaymentGuard],
        loadChildren: './stripe-apple-payment/stripe-apple-payment.module#StripeApplePaymentModule'
    }, {
        path: 'credit-card',
        canActivate: [PaymentGuard],
        loadChildren: './credit-card-payment/credit-card-payment.module#CreditCardPaymentModule'
    }, {
        path: 'eft',
        canActivate: [PaymentGuard],
        loadChildren: './eft-payment/eft-payment.module#EftPaymentModule'
    }, {
        path: 'redirect-payment',
        canActivate: [PaymentGuard],
        loadChildren: './redirect-payment/redirect-payment.module#RedirectPaymentModule'
    }, {
        path: 'mpgs-apple',
        canActivate: [PaymentGuard],
        loadChildren: './mpgs-apple-pay-payment/mpgs-apple-pay-payment.module#MpgsApplePayPaymentModule'
    }, {
        path: 'mpgs-credit-card',
        canActivate: [PaymentGuard],
        loadChildren: './mpgs-credit-card-payment/mpgs-credit-card-payment.module#MpgsCreditCardPaymentModule'
    }, {
        path: 'mpgs-google',
        canActivate: [PaymentGuard],
        loadChildren: './mpgs-google-pay-payment/mpgs-google-pay-payment.module#MpgsGooglePayPaymentModule'
    }, {
        path: 'host-session',
        canActivate: [PaymentGuard],
        loadChildren: './mpgs-host-session/mpgs-host-session.module#MpgsHostSessionModule'
    }, {
        path: 'oepay',
        canActivate: [PaymentGuard],
        loadChildren: './oepay-payment/oepay-payment.module#OepayPaymentModule'
    }, {
        path: 'openrice',
        canActivate: [PaymentGuard],
        loadChildren: './openrice-payment/openrice-payment.module#OpenricePaymentModule'
    }, {
        path: 'stripe-google',
        canActivate: [PaymentGuard],
        loadChildren: './stripe-google-pay-payment/stripe-google-pay-payment.module#StripeGooglePayPaymentModule'
    }, {
        path: 'wechat-open',
        canActivate: [PaymentGuard],
        loadChildren: './wechat-open-payment/wechat-open-payment.module#WechatOpenPaymentModule'
    }, {
        path: 'wechat-pay',
        canActivate: [PaymentGuard],
        loadChildren: './wechat-pay-payment/wechat-pay-payment.module#WechatPayPaymentModule'
    }, {
        path: 'wirecard-v2',
        canActivate: [PaymentGuard],
        loadChildren: './wirecard-v2-payment/wirecard-v2-payment.module#WirecardV2PaymentPageModule'
    }, {
        path: 'mid-trans',
        canActivate: [PaymentGuard],
        loadChildren: './mid-trans-payment/mid-trans-payment.module#MidTransPaymentModule'
    }
];

@NgModule({
    imports: [
        RouterModule.forChild(
            routes
        )],
    exports: [RouterModule],
})
export class PaymentRoutingModule {
}
